import React from 'react'
import FormRender from '../../../../utils/newforms/render/FormRender'
import CharCounterHint from '../../seo/CharCounterHint'
import SingleSeoImageManager from '../../seo/SingleSeoImageManager/SingleSeoImageManager'
import SeoSectionShell from '../../seo/SeoSectionShell'
import { SEO_SOFT_LIMITS } from '../../seo/defaultSeo'
import '../../seo/LandingSeoSection.sass'

function CatalogTaxonomyNodeSeoSection({ form, setForm, ogImage, setOgImage }) {
  if (!form) return null

  return (
    <SeoSectionShell
      title="SEO та контент категорії"
      bodyClassName="LandingSeoSection LandingSeoSection_embedded LandingSeoSection_inSpoiler"
    >
      <div className="LandingSeoSection-StatusRow">
        <div className="LandingSeoSection-StatusField">
          <FormRender sections={[{ fields: ['reviewStatus'] }]} form={form} setForm={setForm} errors={false} />
        </div>
        <div className="LandingSeoSection-StatusField">
          <FormRender sections={[{ fields: ['indexationMode'] }]} form={form} setForm={setForm} errors={false} />
        </div>
      </div>
      <p className="LandingSeoSection-StatusHint">
        Review status — внутрішній статус редактури. Indexation mode: «Автоматично» = правила вітрини; «Не
        індексувати» = ручна заборона.
      </p>

      <section className="LandingSeoSection-Section">
        <p className="LandingSeoSection-SectionTitle">Мета-теги та Open Graph</p>

        <div className="LandingSeoSection-MetaGrid">
          <div className="LandingSeoSection-MetaCol">
            <FormRender sections={[{ fields: ['title'] }]} form={form} setForm={setForm} errors={false} />
            <CharCounterHint
              value={form.title?.value}
              softLimit={SEO_SOFT_LIMITS.title}
              helperText="Якщо порожньо — вітрина згенерує title автоматично"
            />

            <FormRender sections={[{ fields: ['metaDescription'] }]} form={form} setForm={setForm} errors={false} />
            <CharCounterHint
              value={form.metaDescription?.value}
              softLimit={SEO_SOFT_LIMITS.metaDescription}
              helperText="Короткий опис для сніпета пошуку"
            />
          </div>

          <div className="LandingSeoSection-MetaCol">
            <FormRender sections={[{ fields: ['ogTitle'] }]} form={form} setForm={setForm} errors={false} />
            <CharCounterHint
              value={form.ogTitle?.value}
              softLimit={SEO_SOFT_LIMITS.ogTitle}
              helperText="Якщо порожньо — візьметься SEO title"
            />

            <FormRender sections={[{ fields: ['ogDescription'] }]} form={form} setForm={setForm} errors={false} />
            <CharCounterHint
              value={form.ogDescription?.value}
              softLimit={SEO_SOFT_LIMITS.ogDescription}
              helperText="Якщо порожньо — візьметься meta description"
            />
          </div>
        </div>

        <div className="LandingSeoSection-OgImage">
          <p className="LandingSeoSection-SectionTitle">OG image</p>
          <SingleSeoImageManager
            formData={ogImage}
            syncState={setOgImage}
            helperText="Зображення для шарингу в соцмережах. Не змінює системні фото категорії."
          />
        </div>
      </section>

      <section className="LandingSeoSection-Section">
        <p className="LandingSeoSection-SectionTitle">Контент сторінки</p>

        <FormRender sections={[{ fields: ['h1'] }]} form={form} setForm={setForm} errors={false} />
        <CharCounterHint
          value={form.h1?.value}
          helperText="Override публічного H1; не змінює системну назву категорії"
        />

        <div className="LandingSeoSection-ContentGrid">
          <div className="LandingSeoSection-MetaCol">
            <FormRender sections={[{ fields: ['introText'] }]} form={form} setForm={setForm} errors={false} />
          </div>
          <div className="LandingSeoSection-MetaCol">
            <FormRender sections={[{ fields: ['bottomText'] }]} form={form} setForm={setForm} errors={false} />
          </div>
        </div>
      </section>
    </SeoSectionShell>
  )
}

export default CatalogTaxonomyNodeSeoSection
